export default {
    genre: "/story_genres/",
    tags: "/story_tags/",
    ageRating: "/story_age_ratings/",
    chapter: "/chapters/",
    story: "/stories/",
    status: "/story_statuses/",
    role: "/roles/",
}